import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField } from 'formik'
import { FieldName } from '@dhl/receiver-address-format-api'

export const createName = (name: string, fieldName: FieldName): string =>
  `${name}.${fieldName[0].toLowerCase() + fieldName.slice(1)}`

export const useAddressField = (
  name: string,
  fieldName: FieldName
): [FieldInputProps<string>, FieldMetaProps<string>, FieldHelperProps<string>] =>
  useField<string>(createName(name, fieldName))
